import { gql } from '@apollo/client';

export const OFFERS_QUERY = gql`
  query offers(
    $filter: [FilterMap]
    $pageNo: Int
    $pageSize: Int
    $sortCol: String
    $sortDirection: String
  ) {
    offers(
      filter: $filter
      pageNo: $pageNo
      pageSize: $pageSize
      sortCol: $sortCol
      sortDirection: $sortDirection
    ) {
      offers {
        createdAt
        id
        activeBids
        inactiveBids
        offerType
        totalQty
        rate
        validityInHours
        city {
          cityName
        }
        state {
          stateName
        }
        grade {
          id
          name
        }
        rateUnit {
          isoCurrencyCode
        }
        status
        trader {
          id
          firstName
          lastName
          status
          phone
        }
      }
      totalPages
      totalCount
      action
    }
  }
`;

export const DEMANDS_QUERY = gql`
  query demands(
    $filter: [FilterMap]
    $pageNo: Int
    $pageSize: Int
    $sortCol: String
    $sortDirection: String
  ) {
    demands(
      filter: $filter
      pageNo: $pageNo
      pageSize: $pageSize
      sortCol: $sortCol
      sortDirection: $sortDirection
    ) {
      demands {
        id
        createdAt
        activeBids
        inactiveBids
        demandType
        totalQty
        rate
        validityInHours
        grades {
          id
          name
        }
        rateUnit {
          isoCurrencyCode
        }
        city {
          cityName
        }
        state {
          stateName
        }
        status
        trader {
          id
          firstName
          lastName
          status
          phone
        }
      }
      totalPages
      totalCount
    }
  }
`;

export const EXPORTS_BIDS = gql`
  query exportBids(
    $filter: [FilterMap]
    $sortCol: String
    $sortDirection: String
  ) {
    exportBids(
      filter: $filter
      sortCol: $sortCol
      sortDirection: $sortDirection
    )
  }
`;
